<template>
  <el-col id="day-buttons" :span="4">
    <el-row type="flex" align="middle" justify="end">
      <el-button
        v-if="canAction('editDayParams')"
        type="success"
        icon="el-icon-edit"
        size="small"
        circle
        @click="$emit('set', day, 'dialog_load_day')"
      />
      <el-button
        v-if="canAction('changeDayStatus')"
        class="red"
        :loading="isDayLoading(day.id) || isStatusLoading"
        :type="day.status === 1 ? 'success' : 'danger'"
        :icon="`el-icon-${day.status === 1 ? 'check' : 'close'}`"
        size="small"
        @click="$emit('close')"
      >
        {{ day.status === 1 ? 'Открыть' : 'Закрыть' }}
      </el-button>
    </el-row>
    <el-row class="ta-r go-to-day">
      <el-button type="text" @click.native="goToLoadDay">Подробнее</el-button>
    </el-row>
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DayButtons',
  props: {
    bidId: {
      type: Number,
      default: 0,
    },
    day: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      isDayLoading: 'bids/isDayLoading',
      getLoading: 'bids/getLoading',
    }),
    isStatusLoading() {
      return this.getLoading('Modal')
    },
  },
  methods: {
    goToLoadDay() {
      const { bidId, day } = this

      this.$router.push({
        name: 'LoadDay',
        params: { bidId, loadDayId: day.id },
      })
    },
  },
}
</script>

<style lang="sass">
#day-buttons
  .el-button--danger.red
    background-color: #f00
    border-color: #f00
    &:hover
     background-color: #F56C6C
     border-color: #F56C6C
  .go-to-day
    margin-right: 10px
    height: 30px
    .el-button--text
      padding: 0
      margin-top: 15px
</style>
